import { useContextualBrowseEnabled } from '../hooks/useContextualBrowseEnabled'

interface SubcategoryTitleProps {
  name: string
}

export const SubcategoryTitle = ({ name }: SubcategoryTitleProps) => {
  const { enabled } = useContextualBrowseEnabled()

  if (!enabled) return null

  return <h6 className='mc-mt-3 mc-ml-3 mc-text-h6'>{name}</h6>
}
